import { Link, useLocation } from 'react-router-dom';
import { QuestionMarkCircleIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { cn } from '@/lib/utils';

const TopQuickMenu = () => {
  const location = useLocation();
  
  const quickItems = [
    {
      href: '/support/faq',
      label: 'Support',
      icon: QuestionMarkCircleIcon,
      description: 'Get help and find answers'
    },
    {
      href: '/contact',
      label: 'Contact',
      icon: ChatBubbleLeftRightIcon,
      description: 'Get in touch with our team'
    }
  ];

  const isActive = (href: string) => location.pathname === href;


  return (
    <div className="bg-muted/30 border-b border-border/30 py-2">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-end space-x-4">
          {quickItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <Link
                key={item.href}
                to={item.href}
                className={cn(
                  "flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition-all duration-200 border",
                  isActive(item.href)
                    ? "text-primary border-primary/20"
                    : "text-muted-foreground border-transparent hover:text-primary hover:hover:border-primary/50 hover:shadow-raised"
                )}
                title={item.description}
              >
                <IconComponent className="h-4 w-4" />
                <span className="hidden sm:inline">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TopQuickMenu;